module.exports = __webpack_public_path__ + "static/media/Alison Welwood.0a72763d.png";